module.exports = __webpack_public_path__ + "static/media/Leccion-4-30-El-Servicio-Como-Adoracion.c0ff77d0.pdf";